import { useEffect, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { useUiStore } from "@/stores/ui.store";
import i18n from "@/i18n";

export function Providers({ children }: { children: ReactNode }) {
  const init = useUiStore((s) => s.init);
  const language = useUiStore((s) => s.language);

  useEffect(() => {
    init();
  }, [init]);

  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [language]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
